export default __webpack_public_path__ + "static/media/trends.2cacbfc6.svg";